import { AllowedAccess } from 'react-permission-role'
import { useLocation, useParams } from 'react-router-dom'
import {
    Box,
    Button,
    Card,
    CardContent
} from '@mui/material';

import { useFetchInitCashierOperations } from './hooks'

import { TableOperations } from './TableOperations'
import { FormOperations } from './FormOperations'

export const CashierOperations = () => {

    const location = useLocation();
    const paramsURL = useParams();
    const useFetchInit = useFetchInitCashierOperations({location, paramsURL})

    const { Actions, globalStates } = useFetchInit

    const { handleClickShowForm } = Actions
    const { showForm } = globalStates

    return (
        <AllowedAccess permissions={['244_OPERACIONES']} renderAuthFailed={<p>Error</p>}>
            {(!showForm) && (
                <Card sx={{ zIndex: 1 }}>
                    <CardContent>
                        
                        <div className='h4 mt-1 mb-1'> Cajas: Operaciones </div>
                        <div className="border-bottom border-dark"></div>

                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', pt: 3, pb: 3 }}>
                            <Button
                                sx={{ backgroundColor: '#4b4b4c' }}
                                variant="contained"
                                type="button"
                                onClick={handleClickShowForm}
                            >
                                + Agregar
                            </Button>
                        </Box>

                        <TableOperations useFetchInit={useFetchInit} />

                    </CardContent>
                </Card>
            )}
            {(showForm) && (
                <FormOperations useFetchInit={useFetchInit} />
            )}
        </AllowedAccess>
    )
}